import { fetchConfig, CartPerformance } from "./shopify.js";
import { subscribe, publish } from "./pubsub.js";
import { PUB_SUB_EVENTS } from "./gw.js";
if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.isCardForm = !!this.closest("card-product");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        if (this.isCardForm) {
          this.variantInputChangeUnsubscriber = subscribe(
            `${PUB_SUB_EVENTS.optionValueSelectionChange}:${this.productId}`,
            (event) => {
              try {
                const variantId = event.data.target.dataset.optionVariantId;
                this.updateCardVariantId(variantId);
              } catch (e) {
                console.error(e);
              }
            },
          );
        }
      }
      disconnectedCallback() {
        if (this.variantInputChangeUnsubscriber) {
          this.variantInputChangeUnsubscriber();
        }
      }
      get productId() {
        var _a;
        return (_a = this.querySelector('input[name="product-id"]')) == null
          ? void 0
          : _a.value;
      }
      updateCardVariantId(id) {
        const wishlistButton = this.closest("card-product").querySelector(
          '[data-swaction="addToWishlist"]',
        );
        if (!wishlistButton) return;
        wishlistButton.dataset.variantId = id;
        this.variantIdInput.value = id;
      }
      onSubmitHandler(evt) {
        var _a;
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        (_a = this.querySelector(".loading__spinner")) == null
          ? void 0
          : _a.classList.remove("hidden");
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            }
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }
            const gwCustomerAccounts = document.querySelector(
              "gw-customer-accounts",
            );
            if (gwCustomerAccounts) {
              const event = new CustomEvent("gw:saved-items-from-cart", {
                detail: {
                  productId: this.form.querySelector('[name="product-id"]')
                    .value,
                  variantId: this.form.querySelector('[name="id"]').value,
                  target: this.form,
                  extra: "items" in response ? response.items : response,
                },
              });
              gwCustomerAccounts.dispatchEvent(event);
            }
            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers",
            );
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker,
                );
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        this.cart.renderContents(response);
                      },
                    );
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            var _a2;
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            (_a2 = this.querySelector(".loading__spinner")) == null
              ? void 0
              : _a2.classList.add("hidden");
            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );
        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          const isPreorder = this.submitButton.hasAttribute("data-preorder");
          const textContent = isPreorder
            ? window.variantStrings.preorder
            : window.variantStrings.addToCart;
          let buttonInnerHTML = `
            ${textContent}
          `;
          if (this.submitButton.hasAttribute("data-show-price")) {
            buttonInnerHTML += `<span class="button__suffix product-form__submit-price">${this.dataset.price}</span>`;
          }
          this.submitButtonText.innerHTML = buttonInnerHTML;
        }
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
